import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import BookmarkAddedRoundedIcon from '@mui/icons-material/BookmarkAddedRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import MoreTimeRoundedIcon from '@mui/icons-material/MoreTimeRounded';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import BeachAccessRoundedIcon from '@mui/icons-material/BeachAccessRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import FolderSharedRoundedIcon from '@mui/icons-material/FolderSharedRounded';
import MarkEmailUnreadRoundedIcon from '@mui/icons-material/MarkEmailUnreadRounded';
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutlineRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import ApprovalRoundedIcon from '@mui/icons-material/ApprovalRounded';
import ContactPageRoundedIcon from '@mui/icons-material/ContactPageRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import RouteRoundedIcon from '@mui/icons-material/RouteRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import HistoryToggleOffRoundedIcon from '@mui/icons-material/HistoryToggleOffRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

export const MODULE_GROUPS = [
    {
        group: 'Main',
        color: '#7C5CFC',
        items: [
            { key: 'dashboard', label: 'Dashboard', icon: SpaceDashboardRoundedIcon },
            { key: 'employees', label: 'Employees', icon: GroupsRoundedIcon },
            { key: 'employee-onboarding', label: 'Onboard Employee', icon: PersonAddAlt1RoundedIcon },
            { key: 'resignations', label: 'Resignations', icon: LogoutRoundedIcon },
            { key: 'inbox', label: 'Inbox', icon: MarkEmailUnreadRoundedIcon },
        ],
    },
    {
        group: 'Recruitment',
        color: '#E11D48',
        items: [
            { key: 'recruitment-categories', label: 'Job Categories', icon: CategoryRoundedIcon },
            { key: 'recruitment-vacancies', label: 'Vacancies', icon: WorkOutlineRoundedIcon },
            { key: 'recruitment-candidates', label: 'Candidates', icon: PersonSearchRoundedIcon },
            { key: 'recruitment-interviews', label: 'Interviews', icon: EventAvailableRoundedIcon },
            { key: 'careers-settings', label: 'Careers Settings', icon: PublicRoundedIcon },
        ],
    },
    {
        group: 'Documents',
        color: '#DB2777',
        items: [
            { key: 'document-requests', label: 'Requests', icon: NoteAddRoundedIcon },
            { key: 'document-approvals', label: 'Approvals', icon: ApprovalRoundedIcon },
            { key: 'organisation-documents', label: 'Organisation Documents', icon: FolderSharedRoundedIcon },
            { key: 'employee-documents', label: 'Employee Documents', icon: ContactPageRoundedIcon },
        ],
    },
    {
        group: 'Attendance',
        color: '#16A34A',
        items: [
            { key: 'attendance-overview', label: 'Overview', icon: GridViewRoundedIcon },
            { key: 'attendance', label: 'Attendance', icon: HowToRegRoundedIcon },
            { key: 'attendance-reports', label: 'Reports', icon: AssessmentRoundedIcon },
            { key: 'client-locations', label: 'Client Locations', icon: PlaceRoundedIcon },
            { key: 'location-tracking', label: 'Location Tracking', icon: RouteRoundedIcon },
        ],
    },
    {
        group: 'Leave',
        color: '#0D9488',
        items: [
            { key: 'leave-applications', label: 'Applications', icon: ListAltRoundedIcon },
            { key: 'leave-apply', label: 'Apply Leave', icon: BeachAccessRoundedIcon },
            { key: 'leave-my-requests', label: 'My Requests', icon: HistoryToggleOffRoundedIcon },
            { key: 'leave-approval', label: 'Leave Approval', icon: FactCheckRoundedIcon },
            { key: 'permission-apply', label: 'Apply Permission', icon: MoreTimeRoundedIcon },
            { key: 'permission-approve', label: 'Approve Permission', icon: FactCheckRoundedIcon },
            { key: 'permission-marked', label: 'Marked Permission', icon: BookmarkAddedRoundedIcon },
        ],
    },
    {
        group: 'Payroll',
        color: '#0EA5E9',
        items: [
            { key: 'payroll-register', label: 'Payroll Register', icon: ReceiptLongRoundedIcon },
            { key: 'run-payroll', label: 'Run Payroll', icon: PaidRoundedIcon },
            { key: 'payslips', label: 'Payslips', icon: FactCheckRoundedIcon },
            { key: 'advances', label: 'Salary Advances', icon: SavingsRoundedIcon },
            { key: 'overtime', label: 'Overtime (OT)', icon: MoreTimeRoundedIcon },
            { key: 'payroll-incentives', label: 'Payroll Incentives', icon: CardGiftcardRoundedIcon },
            { key: 'increments', label: 'Regular Increments', icon: TrendingUpRoundedIcon },
            { key: 'increments-growth', label: 'Growth Increments', icon: TrendingUpRoundedIcon },
        ],
    },
    {
        group: 'Expenses',
        color: '#F59E0B',
        items: [
            { key: 'expenses-daily', label: 'Daily Expenses', icon: ReceiptLongRoundedIcon },
            { key: 'expenses-shoot', label: 'Shoot Expenses', icon: ReceiptLongRoundedIcon },
            { key: 'expenses-other', label: 'Other Expenses', icon: CategoryRoundedIcon },
        ],
    },
    {
        group: 'Organisation',
        color: '#0891B2',
        items: [
            { key: 'departments', label: 'Departments', icon: AccountTreeRoundedIcon },
            { key: 'designations', label: 'Designations', icon: WorkspacePremiumRoundedIcon },
            { key: 'roles-access', label: 'Roles & Access', icon: AdminPanelSettingsRoundedIcon },
            { key: 'entities', label: 'Business Entities', icon: ApartmentRoundedIcon },
        ],
    },
    {
        group: 'Payroll Setup',
        color: '#6246E0',
        items: [
            { key: 'salary-structures', label: 'Salary Structures', icon: RequestQuoteRoundedIcon },
            { key: 'salary-unlock', label: 'Unlock Salary Figures', icon: VerifiedUserRoundedIcon },
            { key: 'statutory-deductions', label: 'Statutory Deductions', icon: VerifiedUserRoundedIcon },
        ],
    },
    {
        group: 'Leave Policy',
        color: '#F59E0B',
        items: [
            { key: 'policy-setup', label: 'Policy Setup', icon: RuleRoundedIcon },
            { key: 'leave-types', label: 'Leave Types', icon: CategoryRoundedIcon },
            { key: 'working-calendar', label: 'Working Calendar', icon: CalendarMonthRoundedIcon },
            { key: 'assign-shifts', label: 'Assign Shifts', icon: ScheduleRoundedIcon },
        ],
    },
    {
        group: 'System',
        color: '#64748B',
        items: [
            { key: 'settings', label: 'Settings', icon: SettingsRoundedIcon },
        ],
    },
];

export const ALL_MODULES = MODULE_GROUPS.flatMap((g) => g.items);
export const ALL_MODULE_KEYS = ALL_MODULES.map((i) => i.key);
export const TOTAL_MODULES = ALL_MODULE_KEYS.length;

const FALLBACK_ICON = GridViewRoundedIcon;

export const MODULE_ICONS = ALL_MODULES.reduce(
    (acc, m) => ({ ...acc, [m.key]: m.icon }),
    {
        'salary-credited': PaidRoundedIcon,
        'salary-register': ReceiptLongRoundedIcon,
        'run-approve': FactCheckRoundedIcon,
        'approve-payroll': FactCheckRoundedIcon,
        compliance: VerifiedUserRoundedIcon,
        'leave-management': BeachAccessRoundedIcon,
        overview: GridViewRoundedIcon,
        reports: AssessmentRoundedIcon,
        roles: AdminPanelSettingsRoundedIcon,
        recruitment: WorkOutlineRoundedIcon,
        documents: FolderSharedRoundedIcon,
    },
);

export const iconForModule = (moduleKey) => MODULE_ICONS[moduleKey] || FALLBACK_ICON;

const CATEGORY_COLOURS = MODULE_GROUPS.reduce(
    (acc, g) => ({ ...acc, [g.group]: g.color }),
    { General: '#7C5CFC', 'Leave & Attendance': '#16A34A' },
);
const DEFAULT_COLOUR = '#64748B';

export const groupsFromRoleAccess = (categories = []) =>
    categories.map((c) => ({
        group: c.category,
        color: CATEGORY_COLOURS[c.category] || DEFAULT_COLOUR,
        items: (c.modules || []).map((m) => ({
            key: m.moduleKey,
            moduleId: m.moduleId,
            label: m.name,
            icon: iconForModule(m.moduleKey),
        })),
    }));

export const groupModulesByCategory = (modules = []) => {
    const groups = [];
    const byCategory = new Map();

    modules.forEach((m) => {
        const category = m.category || 'Other';
        if (!byCategory.has(category)) {
            const group = {
                group: category,
                color: CATEGORY_COLOURS[category] || DEFAULT_COLOUR,
                items: [],
            };
            byCategory.set(category, group);
            groups.push(group);
        }
        byCategory.get(category).items.push({
            key: m.moduleKey,
            moduleId: m.moduleId,
            label: m.name,
            icon: iconForModule(m.moduleKey),
            displayOrder: m.displayOrder ?? 0,
        });
    });

    groups.forEach((g) => g.items.sort((a, b) => a.displayOrder - b.displayOrder));
    return groups;
};

export const accessFromKeys = (keys) =>
    ALL_MODULE_KEYS.reduce((acc, k) => ({ ...acc, [k]: keys.includes(k) }), {});
export const accessAll = () =>
    ALL_MODULE_KEYS.reduce((acc, k) => ({ ...acc, [k]: true }), {});
export const countEnabled = (access = {}) =>
    ALL_MODULE_KEYS.filter((k) => access[k]).length;
